module.exports = __webpack_public_path__ + "img/solutionDetailsBj.0953f7bf.png";